import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';

import MainBanner from '../../components/MainBanner';
import LatestNews from '../../components/LatestNews';
import BlogDetails from '../../components/BlogDetails';

export default function ExpertiseIndividualPage({
    global,
    page,
    all_news,
}) {
    return (
        <>
            <SeoHead
                page_name={`${page.title} | Staffing Agency | US and Canada Staffing | Bartech Staffing`}
                canonical_link={`sectors/${page.url_slug}`}
            />
            <MainBanner
                global={global}
                pathPrefix={`sector_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>{page.title}</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
                editableContent={false}
            />
            <BlogDetails
                global={global}
                pathPrefix={`sector_page.blog_details`}
                customClass={`py-5`}
                buttonLink={`/employers/`}
                buttonTitle={`Back to business solutions`}
                post={page}
            />
            <LatestNews
                global={global}
                pathPrefix={`sector_page.latest_news`}
                customClass={`py-5 blueGradientBg top-rounded-radius`}
                post={all_news}
                content={
                    <>
                        <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
                        <p>Our tech expertise and partner-led approach allows us to deliver highly successful results for our clients so they can attract and retain unique talent for their business. Explore our latest collection of case studies, news, events, and insights</p>
                    </>
                }
                buttonLink={`/news-and-insights/`}
                buttonTitle={`View All Insights`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const page = (await Collection('sectors')).getJsonItem(params.url_slug, 'url_slug');

    const news = await Collection('news');

    const all_news = news.orderBy('order').getItems().slice(0, 8);
    return {
        props: {
            global,
            page,
            all_news,
        }
    };
}

export async function getStaticPaths() {
    const pagePath = (await Collection('sectors')).getPaths('url_slug');
    return {
        paths: pagePath,
        fallback: false
    }
}
